<template>
  <div class="switcher">
    <input type="checkbox" :checked="value" @change="$emit('input', !value)" :id="id" class="switcher-input">
    <label :for="id" class="switcher-label"></label>
  </div>
</template>

<script>
export default {
  props: {
    id: String,
    value: Boolean,
  },
};
</script>

<style lang="scss" scoped>
.switcher-input {
  height: 0;
  width: 0;
  visibility: hidden;
}

.switcher-label {
  cursor: pointer;
  text-indent: -9999px;
  width: 40px;
  height: 24px;
  background: transparent;
  border: 1px solid $black-color1;
  display: flex;
  border-radius: 100px;
  position: relative;
}

$side-padding: 3px;
$switcher-size: 16px;
.switcher-label:after {
  content: "";
  position: absolute;
  align-self: center;
  left: $side-padding;
  width: $switcher-size;
  height: $switcher-size;
  background: $white-color2;
  border: 1px solid $red-color3;
  border-radius: 10px;
  transition: $transition/2;
  will-change: left, transform;
}


.switcher-input:checked + .switcher-label:after {
  left: calc(100% - #{$side-padding});
  transform: translateX(-100%);
}

</style>



// WEBPACK FOOTER //
// src/components/uikit/SwitcherEl.vue